module.exports = ['$scope', '$state', '$stateParams', '$location', '$anchorScroll', function ($scope, $state, $stateParams, $location, $anchorScroll) {
    var activeStyle = '';
    $location.hash('scrollto');

    if (typeof ($stateParams.style) === 'string') {
        activeStyle = $stateParams.style;
    }

    $scope.styleOptions = [
        {
            id: 'stand-out',
            name: 'Stand Out'
        },
        {
            id: 'blend-in',
            name: 'Blend In'
        }
    ];

    $scope.btnStyleClass = function (option) {
        if (activeStyle === option)
            return 'selected';
    };

    $scope.btnStyleClick = function ($event, option) {
        $event.preventDefault();
        $state.go('style', { style: option });
    };

    $scope.btnContinueClass = function () {
        if (activeStyle === '')
            return 'disabled';
        return 'active';
    }

    $scope.btnBackClick = function ($event) {
        $event.preventDefault();
        $state.go('color');
        $anchorScroll();
    };

    $scope.btnContinueClick = function ($event) {
        $event.preventDefault();
        $state.go('primary-color', { style: activeStyle });
        $anchorScroll();
    };
}];
